import { MapSetting } from '../settings/map.settings';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { HttpCssClient } from '../shared/http-request.interceptor';
import * as i0 from "@angular/core";
import * as i1 from "../shared/http-request.interceptor";
var MapsService = /** @class */ (function () {
    function MapsService(http) {
        this.http = http;
    }
    MapsService.prototype.getMapByProduct = function (id) {
        var uri = MapSetting.MAP_ENDPOINT;
        uri = uri.replace(':id', id.toString());
        return this.http.get(uri).pipe(map(function (response) {
            var body = response;
            var cache = {};
            body.repeatStops = [];
            body.listStops = [];
            body.icons = [];
            body.routes.map(function (r) {
                r.stoppingPlaces.map(function (stop) {
                    stop.colours = [];
                    stop.colours.push(r.color);
                    body.listStops.push(stop);
                    if (cache[stop.id]) {
                        body.repeatStops.push(stop.id);
                    }
                    else {
                        cache[stop.id] = true;
                    }
                });
            });
            return body;
        }));
    };
    MapsService.ngInjectableDef = i0.defineInjectable({ factory: function MapsService_Factory() { return new MapsService(i0.inject(i1.HttpCssClient)); }, token: MapsService, providedIn: "root" });
    return MapsService;
}());
export { MapsService };
